<template>
  <invest019 />
</template>

<script>
import invest019 from '@/pages/invest/p_invest019.vue';

export default {
  components: {
    invest019
  }
};
</script>
